<div class="p-4 flex-col flex gap-4">
    <div class="flex flex-col gap-1">
        <h3>
            <i class="pi pi-bolt text-amber-500"></i>用電分析
        </h3>
        <div class="text-xs text-slate-500 flex items-center gap-1 pl-6">
            <i class="pi pi-clock"></i>
            <span>採樣時間 {{ data()?.sampledAt | date:'yyyy/MM/dd HH:mm:ss' }}</span>
        </div>
    </div>

    <!-- Scope Select -->
    <div class="w-full">
        <p-selectButton unselectable [options]="scopeOptions()" [ngModel]="selectedScope()" (ngModelChange)="onScopeChange($event)" optionLabel="label" optionValue="value"
            styleClass="w-full grid grid-cols-3" [style]="{'width':'100%'}">
        </p-selectButton>
    </div>

    <!-- Power Consumption Comparison -->
    <div class="flex flex-col gap-2">
        <h4 class="text-sm font-bold text-slate-700">總用電量對比</h4>
        <div class="w-full h-[150px]">
            <p-chart type="bar" [data]="chartData()" [options]="chartOptions()" height="100%"></p-chart>
        </div>

        <!-- Comparison Text -->
        <div
            class="text-center text-sm font-bold text-slate-700 bg-white border border-amber-400 rounded-lg py-1.5 px-2 shadow-sm">
            今日累積用電量為上週同日全天的 <span class="text-green-600 font-bold">{{ currentRatio() }}%</span>
        </div>
    </div>

    <div class="border-b border-slate-200 w-full"></div>

    <!-- Carbon Emission Comparison -->
    <div class="flex flex-col gap-2">
        <h4 class="text-sm font-bold text-slate-700">碳排放量對比</h4>

        <div class="grid grid-cols-2 gap-3">
            <!-- Last Week -->
            <div class="bg-white rounded-lg p-3 shadow-sm border border-slate-200 flex flex-col justify-center">
                <div class="text-xs text-slate-500">上週同日全天</div>
                <div class="text-xl font-bold text-slate-800 flex items-baseline gap-1">
                    {{ (data()?.carbonEmission?.lastWeekEmission || 0) | number:'1.0-1' }}
                    <span class="text-xs text-slate-400 ml-1">kgCO2e</span>
                </div>
            </div>

            <!-- Today -->
            <div class="bg-green-50 rounded-lg p-3 shadow-sm border border-green-500 flex flex-col justify-center">
                <div class="text-xs text-slate-700">今日累積</div>
                <div class="text-xl font-bold text-green-600 flex items-baseline gap-1">
                    {{ (data()?.carbonEmission?.currentEmission || 0) | number:'1.0-1' }}
                    <span class="text-xs text-slate-500 ml-1">kgCO2e</span>
                </div>
            </div>
        </div>

        <!-- Comparison Text -->
        <div
            class="text-center text-sm font-bold text-slate-700 bg-green-50 border border-green-500 rounded-lg py-1.5 px-2 shadow-sm">
            今日累積碳排放量為上週同日全天的 <span class="text-green-600 font-bold">{{ data()?.carbonEmission?.ratio || 0 }}%</span>
        </div>
    </div>
</div>